import script from "./AvisoVue.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoVue.vue?vue&type=script&setup=true&lang=js"

import "./AvisoVue.vue?vue&type=style&index=0&id=1b717be3&lang=css"

const __exports__ = script;

export default __exports__